import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MdIconComponent } from '@inditex/mduikit';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { getCmsConfigValue, getPage } from '@core/infrastructure/state/core.selectors';
import { isHomePage } from '@features/category/application/services/category.utils';

@Component({
    selector: 'md-logo',
    standalone: true,
    imports: [NgIf, MdIconComponent, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './md-logo.component.html',
})
export class MdLogoComponent {
    private readonly store = inject(Store);

    @Input() public theme: 'DARK' | 'LIGHT' | 'WHITE' | string = 'DARK';

    public isHomePage$: Observable<boolean> = this.store.select(getPage).pipe(
        map((page) => {
            return isHomePage(page);
        }),
    );

    public logoPath$: Observable<Record<string, string>> = this.store.select(getCmsConfigValue('static_logo_path')).pipe(
        map((logoPath) => {
            if (logoPath) {
                return JSON.parse(logoPath);
            }
            return {};
        }),
    );
}
